module.exports = class Field
  constructor: ->
    super
    @attrs(
      'title'
      'value'
      'viewer'
    )


